import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import ProductBrief from "../Product/ProductBrief";
import ElementSpareEdit from "./ElementSpareEdit";

export default class ElementCritAlert extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      failedModels: [],
      demands: [],
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.elementId !== this.props.elementId) {
      this.load();
    }
  }

  loadReferences = async () => {};

  load = async () => {
    const { elementId } = this.props;
    this.setState({ pending: true });

    let storage = [];
    let demandModels = [];
    let failedModels = [];

    let demands = await this.context.api.qa("/demand/list", {
      filter: { element: elementId },
      orderby: ["modelname DESC"],
    });

    demands.forEach((demand) => {
      demandModels.push(demand.model);
    });

    demandModels = demandModels.filter((value, index, arr) => {
      return arr.indexOf(value) === index;
    });

    if (demandModels.length > 0) {
      storage = await this.context.api.qa("/product/list", {
        search: [
          {
            field: "model",
            valarr: demandModels,
          },
        ],
      });
      demands.forEach((demand) => {
        let product = storage.find((item) => item.model === demand.model) || {};
        let balance = product.balance || 0;
        if (demand.volume > balance) {
          failedModels.push(demand.model);
        }
      });
    }

    this.setState({ demands, failedModels, pending: false });
  };

  getModelName = (modelId) => {
    let model = this.state.demands.find((item) => item.model === modelId) || {};
    return model.label || "";
  };

  render() {
    const { pending, demands, failedModels } = this.state;
    if (pending) {
      return (
        <span className="spinner-border text-muted spinner-border-sm"></span>
      );
    }
    return (
      <div>
        {demands.length === 0 && this.props.critical && (
          <div className="alert alert-danger mt-4">
            Критическое оборудование.
            <br />
            Не установлены требования по наличию запасных частей
          </div>
        )}
        {failedModels.length > 0 && (
          <div className="alert bg-light-warning text-warning mt-4">
            Недостаточно складских запасов:
            <ul className="mt-2">
              {failedModels.map((item, idx) => (
                <li key={idx}>{this.getModelName(item)}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}
